define(['angular'], function(angular) {


    /**
     * @class GoodwillGesturesService
     */
    function GoodwillGesturesService(offerService, orderService,commonService) {
        var self = this;

        /**
         * Set the order form data
         * @param {Object} orderForm
         */
        self.setOrderForm = function setOrderForm(orderForm) {
            self.orderForm = orderForm;
        };

        /**
         * update self.isGoodWillGestures value
         * @return {Boolean}
         * @param gestures
         */
        self.updateIsGG = function updateIsGG(gestures) {
            return gestures.reduce(function(prev, curr) {
                return prev || curr;
            });
        };

        /**
         * Calculate and sum generosity for all options of a given type
         * @param  {String} type of the option
         * @param  {Number} nbMonths number of months in the contract
         * @param  {Object} order
         * @param  {Object} tillOptions additional facultative parameter object for options linked to till
         * @return {Number} Sum of all generosity for this option type
         */
        self.calculateGenerosity = function calculateGenerosity(type, nbMonths, order, tillOptions) {
            var options = order.options.filter(function(option) {
                return option.optionType.code === type && option.discount > 0;
            });

            // If no options of this type are discounted
            if (options.length === 0) {
                return 0;
            }

            var prices = _.flatten(
                options.map(function(option) {
                    return option.prices.filter(function(price) {
                        if (type === 'TPE') {
                            // Special condition for TPE prices => if 'ACHAT' same like LOC48
                            if (order.contract.contractType.code === 'ACHAT') {
                                nbMonths = 48;
                            }
                            return (
                                price.marketType.code === order.marketType.code && price.type.code === 'LOC' + nbMonths
                            );
                        }
                        else if (
                            (type === 'MAINTENANCE' || type === 'SAV') &&
                            order.contract.contractType.code === 'ACHAT'
                        ) {
                            // SAV and MAINTENANCE options use LOC48 price on purchase contract
                            return price.marketType.code === order.marketType.code && price.type.code === 'LOC48';
                        }
                        else {
                            return (
                                price.marketType.code === order.marketType.code &&
                                price.type.code === order.contract.contractType.code
                            );
                        }
                    });
                })
            );

            var values = [];
            options.forEach(function(option, index) {
                values.push({
                    discount: option.discount,
                    price: prices[index].value,
                    amount: option.nbOptions
                });
            });
            return values
                .map(function(value) {
                    // types: SAV, MAINTENANCE
                    if (tillOptions) {
                        if (type === 'MAINTENANCE' && offerService.isOlderOffer(order) === false) {
                            return (
                                _getGenerosity(
                                    value.discount,
                                    tillOptions.rateFunction(value.price * tillOptions.amount, tillOptions.rate, 1)
                                ) * nbMonths
                            );
                        }
                        else {
                            return (
                                _getGenerosity(
                                    value.discount,
                                    tillOptions.rateFunction(value.price * tillOptions.amount, tillOptions.rate)
                                ) * nbMonths
                            );
                        }
                        // types: TPE
                    }
                    else {
                        return _getGenerosity(value.discount, value.price) * nbMonths * value.amount;
                    }
                })
                .reduce(function(prev, curr) {
                    return prev + curr;
                }, 0);
        };

        /**
         * Apply generosity formula to a discounted price
         * @param  {Number} discount % as it is typed in the UI
         * @param  {Number} price value
         * @return {Number} generosity on this price
         */
        function _getGenerosity(discount, price) {
            return price * (discount / 100);
        }

        /* Discount */
        self.ALLOWED_DISCOUNT_RATE = 50;

        /* WELCOME BONUS */
        self.WELCOME_BONUSES = {
            CONQUETE: {
                values: [
                    { value: 150, label: '150€ par TPV' },
                    { value: 300, label: '300€ par TPV' }
                ],
                label: 'bienvenue'
            },
            RENOUVELLEMENT: {
                values: [
                    { value: 100, label: '100€ par renouvellement' },
                    { value: 200, label: '200€ par renouvellement' }
                ],
                label: 'fidélité'
            }
        };

        self.getPartExchange = function getPartExchange(type, order) {
            order = order === undefined ? null : order;
            // get the active partExchange for the type (dateEndValidity is null)
            var activePartExchange = self.orderForm.partExchange.filter(obj => {
                return obj.partExchangeTypeCode === type && obj.partExchangeEndDateValidity === null;
            });

            // if no order given, return active partExchange (filtered by type)
            if (order === null) {
                return activePartExchange[0];
            }

            // check if the order has partExchange
            var hasPartExchange =
                order.goodwillGestures !== null &&
                (typeof order.goodwillGestures.amount.scanupPartExchangeId !== 'undefined' ||
                    typeof order.goodwillGestures.amount.tillPartExchangeId !== 'undefined');

            // get all partExchange from the orderForm. Filtered by type
            var allPartExchangeByType = self.orderForm.partExchange.filter(obj => {
                return obj.partExchangeTypeCode === type;
            });

            if (hasPartExchange && order.isSigned) {
                // get the revenues according to the signature date
                var tmpArray = allPartExchangeByType.filter(obj => {
                    if (type === 'TILL') {
                        return obj.partExchangeId === order.goodwillGestures.amount.tillPartExchangeId;
                    }
                    if (type === 'SCANUP') {
                        return obj.partExchangeId === order.goodwillGestures.amount.scanupPartExchangeId;
                    }
                });
                return tmpArray[0];
            }
            else {
                return activePartExchange[0];
            }
        };

        /**
         * Get the revenues depending on their type and validity date
         * Active revenues have no end date validity
         * @param type
         * @param order
         * @returns {*}
         */
        self.getRevenues = function getRevenues(type, order) {
            order = order === undefined ? null : order;
            // get the active revenues for the type (dateEndValidity is null)
            var activeRevenues = self.orderForm.revenues.filter(obj => {
                return obj.typeCode === type && commonService.isInDateRange(order.dateCreated, obj.rateStartDateValidity, obj.rateEndDateValidity);
            });

            // if no order given, return active revenues
            if (order === null) {
                return activeRevenues;
            }

            // Check if the order has revenues
            var isRevenue = order.goodwillGestures && order.goodwillGestures.revenue.rateId;

            // get all the revenues from the orderForm. Filtered by type
            var allRevenuesByType = self.orderForm.revenues.filter(obj => {
                return obj.typeCode === type;
            });

            if (isRevenue && order.isSigned) {
                // get the revenues according to the signature date
                return allRevenuesByType.filter(obj => {
                    return (
                        obj.rateStartDateValidity <= order.dateSignature &&
                        (obj.rateEndDateValidity >= order.dateSignature || obj.rateEndDateValidity === null)
                    );
                });
            }
            else {
                return activeRevenues;
            }
        };

        /**
         * Check if a revenue is in an array
         * @param revenue
         * @param arrayRevenue
         * @returns {boolean}
         */
        self.isRevenueInArrayRevenues = function (revenue, arrayRevenue) {
            var result = arrayRevenue.filter(obj => {
                return obj.rateId == revenue.rateId;
            });

            return result.length > 0;
        };

        /**
         * Check if an order has an inactive revenue
         * @param order
         * @param type
         * @returns {*}
         */
        self.hasInactiveRevenue = function isRevenueActive(order, type) {
            // get the active revenues for the type (dateEndValidity is null)
            var activeRevenues = self.orderForm.revenues.filter(obj => {
                return obj.typeCode === type && commonService.isInDateRange(order.dateCreated, obj.rateStartDateValidity, obj.rateEndDateValidity);
            });

            // Check if the order has revenues
            var isRevenue = order.goodwillGestures && order.goodwillGestures.revenue.rateId;

            if (!isRevenue) {
                return false;
            }
            else {
                return !self.isRevenueInArrayRevenues(order.goodwillGestures.revenue, activeRevenues);
            }
        };

        /**
         * Conquest welcome bonus condition
         * @param  {Object}  order
         * @return {Boolean}
         */
        self.isWelcomeBonusConquestType = function isWelcomeBonusConquestType(order) {
            return order.contract.scenarioType.code === 'CONQUETE';
        };

        /**
         * Renewal welcome bonus condition
         * @param  {[type]}  order
         * @return {Boolean}
         */
        self.isWelcomeBonusRenewalType = function isWelcomeBonusRenewalType(order) {
            return order.contract.scenarioType.code === 'RENOUVELLEMENT';
        };

        /* Deloitte */
        var PALIER_DELOITTE = 1500;

        /**
         * is a given order is eligible for Deloitte subvention
         * @param  {Object} order
         * @return {Boolean}
         */
        self.isDeloitteAvailable = function isDeloitteAvailable(order) {
            return (
                (order.marketType.code === 'TABACPRESSE' || order.marketType.code === 'AUTRE') &&
                (order.client.storeActivityCode === 'PRESSE' || order.client.storeActivityCode === 'TABACPRESSE') &&
                order.prices.proforma > PALIER_DELOITTE
            );
        };

        /* Cashin Services  */

        self.CASHIN_SERVICES_MONTHLY_AMOUNT = 40;
        self.CASHIN_SERVICES_NUMBER_OF_MONTHS = 12;

        self.calculateCashinServiceTotal = function calculateCashinServiceTotal() {
            return self.CASHIN_SERVICES_MONTHLY_AMOUNT * self.CASHIN_SERVICES_NUMBER_OF_MONTHS;
        };

        /* Festival des Services  */

        self.SERVICES_FESTIVAL_MONTHLY_AMOUNT = 50;
        self.SERVICES_FESTIVAL_NUMBER_OF_MONTHS = 6;

        self.calculateServiceFestivalTotal = function calculateServiceFestivalTotal() {
            return self.SERVICES_FESTIVAL_MONTHLY_AMOUNT * self.SERVICES_FESTIVAL_NUMBER_OF_MONTHS;
        };

        /* Eagle  */

        self.EAGLE_MONTHLY_AMOUNT_SEGMENT1_1CAISSE = 60;
        self.EAGLE_MONTHLY_AMOUNT_SEGMENT1_2CAISSE = 100;
        self.EAGLE_MONTHLY_AMOUNT_SEGMENT1_3CAISSE = 120;

        self.EAGLE_MONTHLY_AMOUNT_SEGMENT2_1CAISSE = 50;
        self.EAGLE_MONTHLY_AMOUNT_SEGMENT2_2CAISSE = 85;
        self.EAGLE_MONTHLY_AMOUNT_SEGMENT2_3CAISSE = 100;

        self.EAGLE_MONTHLY_AMOUNT_SEGMENT3_1CAISSE = 40;
        self.EAGLE_MONTHLY_AMOUNT_SEGMENT3_2CAISSE = 70;
        self.EAGLE_MONTHLY_AMOUNT_SEGMENT3_3CAISSE = 80;


        self.calculateEagleTotal = function (order) {
            const segmentTypeCode = order.goodwillGestures.segment.segmentCode;
            let nbTills = 0;
            const contract = order.contract.contractType.code;
            let value = 0;

            order.tills.map(till => nbTills += till.nbTills)

            if(contract === 'ACHAT' || contract === 'LOC48'){
                if(segmentTypeCode === 'SEGMENT1'){
                    if (nbTills === 1)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT1_1CAISSE * 48 ;
                    if (nbTills === 2)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT1_2CAISSE * 48 ;
                    if (nbTills >= 3)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT1_3CAISSE * 48 ;
                }
                if(segmentTypeCode === 'SEGMENT2'){
                    if (nbTills === 1)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT2_1CAISSE * 48 ;
                    if (nbTills === 2)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT2_2CAISSE * 48 ;
                    if (nbTills >= 3)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT2_3CAISSE * 48 ;
                }
                if(segmentTypeCode === 'SEGMENT3'){
                    if (nbTills === 1)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT3_1CAISSE * 48 ;
                    if (nbTills === 2)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT3_2CAISSE * 48 ;
                    if (nbTills >= 3)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT3_3CAISSE * 48 ;
                }
            }
            if(contract === 'LOC36'){
                if(segmentTypeCode === 'SEGMENT1'){
                    if (nbTills === 1)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT1_1CAISSE * 36 ;
                    if (nbTills === 2)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT1_2CAISSE * 36 ;
                    if (nbTills >= 3)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT1_3CAISSE * 36 ;
                }
                if(segmentTypeCode === 'SEGMENT2'){
                    if (nbTills === 1)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT2_1CAISSE * 36 ;
                    if (nbTills === 2)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT2_2CAISSE * 36 ;
                    if (nbTills >= 3)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT2_3CAISSE * 36 ;
                }
                if(segmentTypeCode === 'SEGMENT3'){
                    if (nbTills === 1)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT3_1CAISSE * 36 ;
                    if (nbTills === 2)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT3_2CAISSE * 36 ;
                    if (nbTills >= 3)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT3_3CAISSE * 36 ;
                }
            }
            if(contract === 'LOC60'){
                if(segmentTypeCode === 'SEGMENT1'){
                    if (nbTills === 1)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT1_1CAISSE * 60 ;
                    if (nbTills === 2)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT1_2CAISSE * 60 ;
                    if (nbTills >= 3)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT1_3CAISSE * 60 ;
                }
                if(segmentTypeCode === 'SEGMENT2'){
                    if (nbTills === 1)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT2_1CAISSE * 60 ;
                    if (nbTills === 2)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT2_2CAISSE * 60 ;
                    if (nbTills >= 3)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT2_3CAISSE * 60 ;
                }
                if(segmentTypeCode === 'SEGMENT3'){
                    if (nbTills === 1)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT3_1CAISSE * 60 ;
                    if (nbTills === 2)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT3_2CAISSE * 60 ;
                    if (nbTills >= 3)
                        value = self.EAGLE_MONTHLY_AMOUNT_SEGMENT3_3CAISSE * 60 ;
                }
            }

            return value;
        };

        /* Launch Bimedia Pay  */
        self.LAUNCH_BIMEDIA_PAY_MONTHLY_AMOUNT = 0;
        self.LAUNCH_BIMEDIA_PAY_NUMBER_OF_MONTHS = 1;

        /* Lancement B Booster  */

        self.LAUNCH_B_BOOSTER_MONTHLY_AMOUNT = 6;
        self.LAUNCH_B_BOOSTER_NUMBER_OF_MONTHS = 12;

        self.calculateLaunchBBoosterTotal = function calculateLaunchBBoosterTotal() {
            return self.LAUNCH_B_BOOSTER_MONTHLY_AMOUNT * self.LAUNCH_B_BOOSTER_NUMBER_OF_MONTHS + 75;
        };

        /* Offre services sur scan'up  */

        self.SCANUP_SERVICES_MONTHLY_AMOUNT_60 = 10;
        self.SCANUP_SERVICES_MONTHLY_AMOUNT = 11;
        self.SCANUP_SERVICES_NUMBER_OF_MONTHS = 12;
        self.SCANUP_SERVICES_UPS_ONLY_NUMBER_OF_MONTHS = 12;  //anciennement 24 mois
        self.SCANUP_SERVICES_TOTAL = 125;

        self.calculateScanupServicesTotal = function(contractType, scanupServices) {
            const numberMonths = scanupServices.isUPS && !scanupServices.isBrinks
                ? self.SCANUP_SERVICES_UPS_ONLY_NUMBER_OF_MONTHS
                : self.SCANUP_SERVICES_NUMBER_OF_MONTHS;
            return contractType === 'LOC60'
                ? self.SCANUP_SERVICES_MONTHLY_AMOUNT_60 * numberMonths
                : contractType === 'ACHAT'
                    ? self.SCANUP_SERVICES_TOTAL
                    : self.SCANUP_SERVICES_MONTHLY_AMOUNT * numberMonths
        };

        /* Money Transfer Services  */

        /**
         * @param order
         * @returns {number}
         */
        self.getMoneyTransferTotalPrice = function getMoneyTransferTotalPrice(order) {
            return order.goodwillGestures.amount.moneyTransferServices;
        };
        /**
         * @param order
         * @returns {number}
         */
        self.getMoneyTransferMonthlyPrice = function getMoneyTransferMonthlyPrice(order) {
            return order.goodwillGestures.amount.moneyTransferServices / orderService.getContractMonths(order);
        };
        /**
         * @param order
         * @returns {number}
         */
        self.getMoneyTransferQuarterlyPrice = function getMoneyTransferQuarterlyPrice(order) {
            return self.calculateMoneyTransferMonthlyPrice(order) * 3;
        };

        /**
         * Get the money transfer levels available for the order
         * the list depends on the offer type
         * @param {object} order
         * @returns {array}
         */
        self.getMoneyTransferLevels = function getMoneyTransferLevels(order) {
            if (!order.goodwillGestures || !order.goodwillGestures.moneyTransfer.enabled) {
                return [];
            }

            const offerType = self.getMoneyTransferOfferType(
                orderService.isScanupSelected(order.options),
                orderService.getNbTills(order.tills)
            );

            return self.orderForm.moneyTransferLevels.filter(level => {
                return level.offerType === offerType;
            });
        };

        /**
         * @param {number} id
         * @returns {object}
         */
        self.getMoneyTransferLevelById = function getMoneyTransferLevelById(id) {
            return self.orderForm.moneyTransferLevels.find(level => {
                return level.id === id;
            });
        };

        /**
         * @param {integer} levelId
         * @param {string} scenarioType
         * @returns {object}
         */
        self.getMoneyTransferCeiling = function getMoneyTransferCeiling(levelId, scenarioType) {
            const isExtension = scenarioType === 'EXTENSION';

            return self.orderForm.moneyTransferCeilings.find(ceiling => {
                return ceiling.levelId === levelId && ceiling.isExtension === isExtension;
            });
        };

        /**
         * @param {number} monthlyPrice
         * @param {object} order
         * @returns {number}
         */
        self.applyCeilingToMonthlyPrice = function applyCeilingToMonthlyPrice(monthlyPrice, order) {
            const ceiling = self.getMoneyTransferCeiling(
                order.goodwillGestures.moneyTransfer.levelId,
                order.contract.scenarioType.code
            );

            if (!ceiling) {
                return 0;
            }

            return monthlyPrice * 3 > ceiling.value ? ceiling.value / 3 : monthlyPrice;
        };

        /**
         * @param {number} refundAmount
         * @param {object} order
         * @returns {number}
         */
        self.applyRefundRateToTill = function applyRefundRateToTill(refundAmount, order) {
            return self.applyMoneyTransferRefundRate(refundAmount, order, 'TILL');
        };

        /**
         * @param {number} refundAmount
         * @param {object} order
         * @returns {number}
         */
        self.applyRefundRateToScanup = function applyRefundRateToScanup(refundAmount, order) {
            return self.applyMoneyTransferRefundRate(refundAmount, order, 'SCANUP');
        };

        /**
         * @param {number} refundAmount
         * @param {object} order
         * @param {string} productType
         * @returns {number}
         */
        self.applyMoneyTransferRefundRate = function applyMoneyTransferRefundRate(refundAmount, order, productType) {
            let refundRate = 0;
            const moneyTransferLevel = self.getMoneyTransferLevelById(order.goodwillGestures.moneyTransfer.levelId);

            if (moneyTransferLevel) {
                refundRate =
                    productType === 'TILL' ? moneyTransferLevel.tillRefundRate : moneyTransferLevel.scanupRefundRate;
            }

            return (refundAmount * refundRate) / 100;
        };

        self.getMoneyTransferOfferType = function getMoneyTransferOfferType(isScanup, numberOfTills) {
            if (isScanup && numberOfTills > 0) {
                return 'TILL_SCANUP';
            }
            else if (numberOfTills > 0) {
                return 'TILL';
            }
            else if (isScanup) {
                return 'SCANUP';
            }

            return '';
        };

        self.getMoneyTransferDescription = function getMoneyTransferDescription(order) {
            let description = '';

            const isScanup = orderService.isScanupSelected(order.options);
            const numberOfTills = orderService.getNbTills(order.tills);
            const contractType = order.contract.contractType.code;

            if (isScanup && numberOfTills > 0) {
                description += "Offre Caisse + Scan'up MT : remboursement du loyer Caisse";
                if (contractType === 'ACHAT') {
                    description +=
                        ' (calculé sur la base du paiement comptant hors pack maintenance et pack Gestion & Accompagnement divisé par 48)';
                }
                else {
                    description += ' (hors pack maintenance et pack Gestion & Accompagnement)';
                }
                description += " et/ou du loyer Scan'up";
                if (contractType === 'ACHAT') {
                    description += ' (calculé sur la base du montant paiement comptant hors options divisé par 48)';
                }
                else {
                    description += ' (hors options)';
                }
            }
            else if (isScanup) {
                description += "Offre Scan'up MT - remboursement du loyer Scan'up";
                if (contractType === 'ACHAT') {
                    description += ' (calculé sur la base du montant paiement comptant hors options divisé par 48)';
                }
                else {
                    description += ' (hors options)';
                }
            }
            else {
                description += 'Offre Caisse MT - remboursement du loyer Caisse ';
                if (contractType === 'ACHAT') {
                    description +=
                        ' (calculé sur la base du paiement comptant hors pack maintenance et pack Gestion & Accompagnement divisé par 48)';
                }
                else {
                    description += ' (hors pack maintenance et pack Gestion & Accompagnement)';
                }
            }
            description += ', selon les paliers suivants :';

            const moneyTransferlevels = self.getMoneyTransferLevels(order);

            for (let i = 0; i < moneyTransferlevels.length; i++) {
                description += '<br/>';
                description += i + 1 + '/ ' + moneyTransferlevels[i].description;
                if (i > 0 && numberOfTills > 1) {
                    description +=
                        ' (calculé en divisant le loyer total hors pack maintenance et pack gestion par le nombre de caisses de la commande)';
                }
            }

            description += '<br/>';
            description +=
                'Avoir trimestriel en fonction du nombre de transactions MG + Ria réalisées sur le trimestre précédent';

            return description;
        };

        /** Exceptional Offer 2023 **/
        self.EXCEPTIONAL_OFFER = {
            1: {
                LOC36: {
                    BT: 109, BS: 149, BSW: 149, BM: 109, BG: 0, BW: 0
                },
                LOC48: {
                    BT: 83, BS: 113, BSW: 113, BM: 83, BG: 0, BW: 0
                },
                LOC60: {
                    BT: 69, BS: 93, BSW: 93, BM: 69, BG: 0, BW: 0
                },
                ACHAT: {
                    BT: 3559, BS: 4849, BSW: 4849, BM: 3559, BG: 0, BW: 0
                }
            },
            2: {
                LOC36: {
                    BT: 189, BS: 252, BSW: 252, BM: 189, BG: 0, BW: 0
                },
                LOC48: {
                    BT: 144, BS: 194, BSW: 194, BM: 144, BG: 0, BW: 0
                },
                LOC60: {
                    BT: 119, BS: 159, BSW: 159, BM: 119, BG: 0, BW: 0
                },
                ACHAT: {
                    BT: 6179, BS: 8329, BSW: 8329, BM: 6179, BG: 0, BW: 0
                }
            },
            3: {
                LOC36: {
                    BT: 268, BS: 359, BSW: 359, BM: 268, BG: 0, BW: 0
                },
                LOC48: {
                    BT: 207, BS: 277, BSW: 277, BM: 207, BG: 0, BW: 0
                },
                LOC60: {
                    BT: 169, BS: 229, BSW: 229, BM: 169, BG: 0, BW: 0
                },
                ACHAT: {
                    BT: 8853, BS: 11879, BSW: 11879, BM: 8853, BG: 0, BW: 0
                }
            }

        }

        const FULL_PREMIUM_MONTHLY_AMOUNT_36 = 14;
        const FULL_PREMIUM_MONTHLY_AMOUNT_48 = 11;
        const FULL_PREMIUM_MONTHLY_AMOUNT_60 = 9;
        const FULL_PREMIUM_AMOUNT_ACHAT = 472;
        self.calculateFullPremiumOfferTotal = (order) => {
            const contract = order.contract.contractType.code;
            if(contract === 'LOC36')
                return FULL_PREMIUM_MONTHLY_AMOUNT_36 * 36;
            if(contract === 'LOC48')
                return FULL_PREMIUM_MONTHLY_AMOUNT_48 * 48;
            if(contract === 'LOC60')
                return FULL_PREMIUM_MONTHLY_AMOUNT_60 * 60;
            return FULL_PREMIUM_AMOUNT_ACHAT
        }

        self.calculateFullPremiumOffer = (order) => {
            const contract = order.contract.contractType.code;
            if(contract === 'LOC36')
                return FULL_PREMIUM_MONTHLY_AMOUNT_36;
            if(contract === 'LOC48')
                return FULL_PREMIUM_MONTHLY_AMOUNT_48;
            if(contract === 'LOC60')
                return FULL_PREMIUM_MONTHLY_AMOUNT_60;
            return FULL_PREMIUM_AMOUNT_ACHAT
        }

        /** offre Bgreen  **/
        const BGREEN_PREMIUM_OFFER_AMOUNT = 22
        const BGREEN_PREMIUM_OFFER_MIXED_AMOUNT = BGREEN_PREMIUM_OFFER_AMOUNT * 0.85;
        const BGREEN_PREMIUM_OFFER_MIXED_AMOUNT_2 = BGREEN_PREMIUM_OFFER_AMOUNT * 0.80 * 2;
        const BGREEN_PREMIUM_OFFER_AMOUNT_2 = BGREEN_PREMIUM_OFFER_AMOUNT * 0.85 * 2;
        const BGREEN_PREMIUM_OFFER_AMOUNT_3 = BGREEN_PREMIUM_OFFER_AMOUNT * 0.80 * 3;

        const BGREEN_ESSENTIEL_OFFER_AMOUNT = 17
        const BGREEN_ESSENTIEL_OFFER_MIXED_AMOUNT = BGREEN_ESSENTIEL_OFFER_AMOUNT * 0.85;
        const BGREEN_ESSENTIEL_OFFER_MIXED_AMOUNT_2 = BGREEN_ESSENTIEL_OFFER_AMOUNT * 0.80 * 2;
        const BGREEN_ESSENTIEL_OFFER_AMOUNT_2 = BGREEN_ESSENTIEL_OFFER_AMOUNT * 0.85 * 2;
        const BGREEN_ESSENTIEL_OFFER_AMOUNT_3 = BGREEN_ESSENTIEL_OFFER_AMOUNT * 0.80 * 3;

        self.calculateBgreenOffer = (isMixed, nbPremium, nbEssentiel, total) => {
            let premiumDiscount, essentialDiscount;
            if(isMixed){
                premiumDiscount = nbPremium === 0 ? 0
                    : nbPremium === 1 ? BGREEN_PREMIUM_OFFER_MIXED_AMOUNT : BGREEN_PREMIUM_OFFER_MIXED_AMOUNT_2;
                essentialDiscount = nbEssentiel === 0 ? 0
                    : nbEssentiel === 1 ? BGREEN_ESSENTIEL_OFFER_MIXED_AMOUNT : BGREEN_ESSENTIEL_OFFER_MIXED_AMOUNT_2;
            }else {
                premiumDiscount = nbPremium === 0 ? 0
                    : nbPremium === 1 ? BGREEN_PREMIUM_OFFER_AMOUNT : nbPremium === 2 ? BGREEN_PREMIUM_OFFER_AMOUNT_2
                    : BGREEN_PREMIUM_OFFER_AMOUNT_3;
                essentialDiscount = nbEssentiel === 0 ? 0
                    : nbEssentiel === 1 ? BGREEN_ESSENTIEL_OFFER_AMOUNT : nbEssentiel === 2 ? BGREEN_ESSENTIEL_OFFER_AMOUNT_2
                    : BGREEN_ESSENTIEL_OFFER_AMOUNT_3;
            }
            let discount = premiumDiscount + essentialDiscount;
            total = typeof total === 'undefined' ? false : total;
            return total ? discount * 48 : discount;
        }

        /* Offre 2025 */
        let offerQ1 = {}
        offerQ1['BM+'] = 17;
        offerQ1['BSW_PREMIUM'] = 17;
        offerQ1['BSW_ESSENTIEL'] = 14;
        offerQ1['PREMIUM'] = 17;
        offerQ1['ESSENTIEL'] = 17;
        offerQ1['BW_PREMIUM'] = 6;
        offerQ1['BW_ESSENTIEL'] = 5;

        let offerQ2TP = {}
        offerQ2TP['BM+'] = 17;
        offerQ2TP['BSW_PREMIUM'] = 17;
        offerQ2TP['BSW_ESSENTIEL'] = 17;
        offerQ2TP['BW_PREMIUM'] = 6;
        offerQ2TP['BW_ESSENTIEL'] = 5;
        offerQ2TP['BC_ESSENTIEL'] = 17;

        let offerQ2T = {}
        offerQ2T['BM+'] = 9;
        offerQ2T['BSW_PREMIUM'] = 15;
        offerQ2T['BSW_ESSENTIEL'] = 15;
        offerQ2T['BW_PREMIUM'] = 0;
        offerQ2T['BW_ESSENTIEL'] = 0;
        offerQ2T['BC_ESSENTIEL'] = 9;

        let offerQ2P = {}
        offerQ2P['BM+'] = 9;
        offerQ2P['BSW_PREMIUM'] = 9;
        offerQ2P['BSW_ESSENTIEL'] = 9;
        offerQ2P['BW_PREMIUM'] = 0;
        offerQ2P['BW_ESSENTIEL'] = 0;
        offerQ2P['BC_ESSENTIEL'] = 9;

        let offer2026TP = {}
        offer2026TP['BM+'] = 12;
        offer2026TP['BSW_PREMIUM'] = 12;
        offer2026TP['BSW_ESSENTIEL'] = 12;
        offer2026TP['BW_PREMIUM'] = 6;
        offer2026TP['BW_ESSENTIEL'] = 5;
        offer2026TP['BC_ESSENTIEL'] = 12;

        let offer2026T = {}
        offer2026T['BM+'] = 5;
        offer2026T['BSW_PREMIUM'] = 10;
        offer2026T['BSW_ESSENTIEL'] = 10;
        offer2026T['BW_PREMIUM'] = 0;
        offer2026T['BW_ESSENTIEL'] = 0;
        offer2026T['BC_ESSENTIEL'] = 5;

        let offer2026P = {}
        offer2026P['BM+'] = 5;
        offer2026P['BSW_PREMIUM'] = 5;
        offer2026P['BSW_ESSENTIEL'] = 5;
        offer2026P['BW_PREMIUM'] = 0;
        offer2026P['BW_ESSENTIEL'] = 0;
        offer2026P['BC_ESSENTIEL'] = 5;


        const COEF_LEASER = {
            'LOC36': 0.03023,
            'LOC48': 0.02332,
            'LOC60': 0.01919,
            'ACHAT': 1
        };

        const COEF_DEGRESSIVE = {
            2: 0.15,
            3: 0.20,
            4: 0.25,
            5: 0.30,
            6: 0.35
        };

        self.calculateQuickInstallOffer = (mixed, contractTypeCode, modules, dateCreated, scenarioTypeCode) => {
            let offer = offerQ1;
            if(moment(dateCreated).isAfter('2025-04-22')) {
                if (moment(dateCreated).isAfter('2026-01-21') && ['RENOUVELLEMENT', 'EXTENSION'].includes(scenarioTypeCode)) {
                    if (modules.length === 2) {
                        offer = offer2026TP;
                    } else {
                        if (modules.find(m => m.code === 'LOGICIEL_CAISSE_TABAC')) {
                            offer = offer2026T;
                        } else {
                            offer = offer2026P;
                        }
                    }
                } else {
                    if (modules.length === 2) {
                        offer = offerQ2TP;
                    } else {
                        if (modules.find(m => m.code === 'LOGICIEL_CAISSE_TABAC')) {
                            offer = offerQ2T;
                        } else {
                            offer = offerQ2P;
                        }
                    }
                }
            }
            let price = 0;
            if(mixed.isMixed){
                let totalNbTills = Object.keys(mixed).reduce((curr, tillType) => {
                    if(mixed[tillType].nbTills && ['FORFAIT', 'PREMIUM_RECONDITIONNE'].indexOf(tillType) === -1)
                        curr += mixed[tillType].nbTills;
                    return curr;
                },0);
                const reduction = totalNbTills > 1 ? 1 - ((totalNbTills - 2) * 0.05 + 0.15) : 0;
                let prices= [];
                Object.keys(mixed).forEach((tillType)=> {
                    if (mixed[tillType].nbTills > 0){
                        let p = offer[tillType];
                        p *= reduction;
                        p = Math.round(p);
                        p *= mixed[tillType].nbTills;
                        prices[tillType] = p;
                    }
                });
                for (const key in prices){
                    price += prices[key];
                }
                let priceUpFront = price / COEF_LEASER['LOC48'];
                price = contractTypeCode === 'LOC48' ? price : priceUpFront * COEF_LEASER[contractTypeCode];
            }else {
                Object.keys(mixed).forEach((tillType)=>{
                    if(mixed[tillType].nbTills > 0) {
                        if (contractTypeCode === 'LOC48') {
                            price = mixed[tillType].nbTills === 1 ? offer[tillType]
                                : offer[tillType] * mixed[tillType].nbTills * (1 - COEF_DEGRESSIVE[mixed[tillType].nbTills]);
                        }else {
                            let priceUpFront = offer[tillType] / COEF_LEASER['LOC48'];
                            price = mixed[tillType].nbTills === 1 ? priceUpFront * COEF_LEASER[contractTypeCode]
                                : priceUpFront * COEF_LEASER[contractTypeCode] * mixed[tillType].nbTills * (1 - COEF_DEGRESSIVE[mixed[tillType].nbTills]);
                        }
                    }
                });
            }
            return Math.ceil(price);
        }

        return self;
    }

    GoodwillGesturesService.$inject = ['offerService', 'orderService', 'commonService'];

    angular
        .module('app.bdc.common.goodwillGesturesService', [])
        .factory('goodwillGesturesService', GoodwillGesturesService);
});
